import React, { useState } from "react";
import premio_fav_icon from '../assest/images/premio_fav_icon.png'
import { Button, Container, Form, Image,Alert } from 'react-bootstrap'
import { ApiService } from "../Components/Service/apiservices";
import { validEmail } from "../Components/Element/Regex";
function NewsLetter() {
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [newsletterDetails, setNewsletterDetails] = useState({
        newsletter_email: "",
    });
    const onTodoChange = (e) => {
        const { name, value } = e.target;
        setNewsletterDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const resetNewsletterForm = () => {
        setNewsletterDetails({ newsletter_email: "" });
    };
    const newsletterProcess = () => {
        let counter = 0;
        const myElements = document.getElementsByClassName("newsletterRequired");
        for (let i = 0; i < myElements.length; i++) {
            if (myElements[i].value == '') {
                myElements[i].style.border = '1px solid red';
                counter++;
            } else {
                myElements[i].style.border = '';
            }
        }
        if (counter == 0) {
            setErrorMessage("");
            if (!validEmail.test(newsletterDetails.newsletter_email)) {
                setErrorMessage("Please enter valid Email Id");
                
                return false;
            }
            ApiService.postData('newsletterprocess', newsletterDetails).then((res) => {
                if (res.status == "success") {
                    setSuccessMessage(res.message)
                    resetNewsletterForm();
                    setTimeout(() => {
                        setSuccessMessage('')
                    }, 2000);
                } else {
                    setErrorMessage(res.message)
                    setTimeout(() => {
                        setErrorMessage('')
                    }, 2000);
                }
            });
        }
    };
    return (
        <div className="subscribe">
            <Container>
                <Image src={premio_fav_icon} className="d-flex m-auto" />
                <h3 className="text-center">Subscribe to our newsletter</h3>
                <p className="text-center">Discover the latest collections, news and exclusive launches from us</p>
                
                <div className="e_mail_box d-flex flex-wrap justify-content-center">
                    <Form>
                        <Form.Group className="newsletterRequired">
                            <Form.Control type="email" placeholder="Email" name="newsletter_email" value={newsletterDetails.newsletter_email} onChange={(e) => onTodoChange(e)} />
                        </Form.Group>
                    </Form>
                    <Button to="#" className="btn_fill border-0" onClick={newsletterProcess}>Sign Up</Button>
                </div>
                {errorMessage && (<Alert variant="danger" className="py-2 px-5 d-table m-auto mt-3">{errorMessage}</Alert>)}
                    {successMessage && (<Alert variant="success" className="py-2 px-5 d-table m-auto mt-3">{successMessage}</Alert>)}
            </Container>
        </div>
    )
}

export default NewsLetter